import { useEffect, useRef } from "react";
import type { PackagingWeek } from "./usePackagingWeeks";
import { formatDay } from "./week39-view";
import { Week39Icon } from "./Week39Icon";

function period(start: string) {
  const end = new Date(`${start}T12:00:00Z`);
  end.setUTCDate(end.getUTCDate() + 5);
  return `${formatDay(start, { day: "numeric", month: "short" })} – ${formatDay(end.toISOString().slice(0, 10), { day: "numeric", month: "short", year: "numeric" })}`;
}

export function PackagingWeekPicker({ weeks, value, label, onChange }: {
  weeks: PackagingWeek[]; value: string; label: string; onChange: (value: string) => void;
}) {
  const details = useRef<HTMLDetailsElement>(null);
  const summary = useRef<HTMLElement>(null);
  useEffect(() => {
    const outside = (event: PointerEvent) => {
      if (event.target instanceof Node && !details.current?.contains(event.target) && details.current) details.current.open = false;
    };
    const escape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && details.current?.open) {
        event.preventDefault(); details.current.open = false; summary.current?.focus();
      }
    };
    document.addEventListener("pointerdown", outside);
    document.addEventListener("keydown", escape);
    return () => { document.removeEventListener("pointerdown", outside); document.removeEventListener("keydown", escape); };
  }, []);
  return <details className="pack39-week-picker" ref={details}>
    <summary ref={summary} aria-label={`Üretim haftası: ${label}`}>
      <span>{label}</span><Week39Icon name="chevron" size={13} className="pack39-week-chevron" />
    </summary>
    <div className="pack39-week-menu" aria-label="Üretim haftaları">
      <p>Üretim haftası seç</p>
      {(weeks.length ? weeks : [{ weekStart: value, label, active: true }]).map((week) => <button key={week.weekStart} type="button"
        aria-current={week.weekStart === value ? "true" : undefined} onClick={() => {
          if (details.current) details.current.open = false;
          if (week.weekStart !== value) onChange(week.weekStart);
          else summary.current?.focus();
        }}>
        <span><strong>{week.label}</strong><span>{period(week.weekStart)}</span></span>
        <small>{week.status === "CLOSED" ? "Kilitli" : week.status === "CARRYOVER" ? "Devredenler" : week.active ? "Güncel" : week.status === "PREPARED" ? "Hazırlanan" : "Arşiv"}</small>
        {week.weekStart === value ? <Week39Icon name="check" size={16} /> : <span className="pack39-week-check-space" />}
      </button>)}
    </div>
  </details>;
}
